export class KeycloakAuthenticationService {
    constructor(keycloakInstace) {
        this.keycloakInstance = keycloakInstace;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async GetServiceAccountToken(_data) {
        return new Promise((resolve) => { resolve(this.keycloakInstance.token); });
    }
}
//# sourceMappingURL=KeycloakAuthenticationService.js.map